import { SerializedEditorState } from "lexical";
import { z } from "zod";

// This is a no-op stub to add typing to the MessageContent type.
function mockIsSerializedEditorState(x: any): x is SerializedEditorState {
  return true;
}

export const AttachmentSchema = z.object({
  cid: z.string(),
  data: z.string(),
  filename: z.string(),
  mimeType: z.string(),
});

export type Attachment = z.infer<typeof AttachmentSchema>;

export const RichContentDocumentSchema = z.object({
  subject: z.string().optional(),
  lexical: z.any().refine(mockIsSerializedEditorState).optional(),
  html: z.string().optional(),
  text: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
  smsLexical: z.any().refine(mockIsSerializedEditorState).optional(),
  smsText: z.string().optional(),
  language: z.string().optional(),
});

export type RichContentDocument = z.infer<typeof RichContentDocumentSchema>;
